<template>
  <BusinessCrud
    title="PC公司新闻"
    :columns="columns"
    :search-fields="searchFields"
    :form-fields="formFields"
    :list-api="getPcNewsList"
    :detail-api="getPcNews"
    :save-api="savePcNews"
    :delete-api="deletePcNews"
    :defaults="{ source: '锐高', coverImage: 'file/fff.png', sortOrder: 0, isTop: 0, viewCount: 0, status: 1 }"
    :modal-width="960"
  />
</template>

<script>
import BusinessCrud from '@/components/BusinessCrud'
import { getPcNewsList, getPcNews, savePcNews, deletePcNews } from '@/api'

export default {
  name: 'PcNewsAdmin',
  components: { BusinessCrud },
  data() {
    return {
      getPcNewsList,
      getPcNews,
      savePcNews,
      deletePcNews,
      searchFields: [
        { key: 'title', label: '新闻标题' },
        { key: 'status', label: '状态', type: 'select', options: [{ label: '显示', value: 1 }, { label: '隐藏', value: 0 }] }
      ],
      columns: [
        { title: '新闻标题', dataIndex: 'title' },
        { title: '来源', dataIndex: 'source', width: 120 },
        { title: '发布日期', dataIndex: 'publishDate', width: 130 },
        { title: '置顶', dataIndex: 'isTop', width: 80, scopedSlots: { customRender: 'status' } },
        { title: '浏览量', dataIndex: 'viewCount', width: 90 },
        { title: '排序', dataIndex: 'sortOrder', width: 80 },
        { title: '状态', dataIndex: 'status', width: 90, scopedSlots: { customRender: 'status' } }
      ],
      formFields: [
        { key: 'title', label: '新闻标题' },
        { key: 'summary', label: '摘要', type: 'textarea', rows: 3 },
        { key: 'coverImage', label: '封面图', type: 'upload-image' },
        { key: 'source', label: '来源' },
        { key: 'publishDate', label: '发布日期', type: 'date' },
        { key: 'contentHtml', label: '新闻正文', type: 'richtext' },
        { key: 'sortOrder', label: '排序', type: 'number', min: 0 },
        { key: 'isTop', label: '是否置顶', type: 'switch' },
        { key: 'status', label: '状态', type: 'switch' }
      ]
    }
  }
}
</script>
